import { Box, Button, Card, Typography } from "@mui/material";
import { AiOutlineDownload } from "react-icons/ai";
import useResponsive from "src/hooks/useResponsive";

interface CarneBannerProps {
  url?: string | null;
}

export default function CarneBanner({ url }: CarneBannerProps) {
  const isMobile = useResponsive("down", "sm");

  const carneUrl = url?.trim();

  if (!carneUrl) return null;

  return (
    <Card
      sx={{
        mb: 3,
        borderRadius: "24px",
        backgroundColor: "#F4F8FD",
        boxShadow: "none",
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: "center",
        justifyContent: "space-between",
        overflow: "hidden",
        px: { xs: 3, md: 6 },
        pt: { xs: 3, md: 0 },
      }}
    >
      <Box sx={{ py: { md: 4 }, textAlign: { xs: "center", md: "left" } }}>
        <Typography
          component="h2"
          sx={{
            fontWeight: 800,
            fontSize: { xs: "28px", md: "40px" },
            lineHeight: 1.1,
            color: "#0B2A6B",
          }}
        >
          Baixe seu
          <br />
          <span style={{ color: "#1A9DAB" }}>Carnê Digital</span>
        </Typography>
        <Typography
          sx={{ mt: 1.5, mb: 2.5, fontSize: { xs: "14px", md: "16px" }, color: "#6B6F8D" }}
        >
          Tenha em mãos todas as mensalidades do seu plano.
        </Typography>
        <Button
          variant="contained"
          size="large"
          endIcon={<AiOutlineDownload />}
          onClick={() => window.open(carneUrl, "_blank")}
          sx={{
            borderRadius: "999px",
            px: 5,
            textTransform: "none",
            fontWeight: 700,
            backgroundColor: "#1A9DAB",
            "&:hover": { backgroundColor: "#15818D" },
          }}
        >
          Baixar Carnê
        </Button>
      </Box>
      <Box
        component="img"
        src="/assets/pdf-carne.png"
        alt="Carnê digital em PDF"
        sx={{
          width: { xs: "70%", sm: "45%", md: "320px" },
          maxWidth: "100%",
          mt: { xs: 2, md: 2 },
          alignSelf: "flex-end",
        }}
      />
    </Card>
  );
}

